import type { ReactNode } from 'react';

import { Glyph } from '@/components/icons';
import { cn } from '@/lib/utils';

export function AlertRow({
  text,
  retry,
  onRetry,
  className,
}: {
  text: ReactNode;
  retry: string;
  onRetry: () => void;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        'bg-bad/10 border-bad rounded-ctl animate-rise-fast flex items-center gap-2.5 border px-3 py-2.5',
        className,
      )}
    >
      <span className="text-t12h min-w-0 flex-1 leading-[1.4] font-bold text-pretty">{text}</span>
      <button
        type="button"
        onClick={onRetry}
        className="bg-bad text-t12 min-h-11 flex-none rounded-xs border-0 px-3.25 font-extrabold text-white active:scale-[.96]"
      >
        {retry}
      </button>
    </div>
  );
}

export function PlayGlyph({ state, size }: { state: 'play' | '…' | '❙❙'; size: number }) {
  if (state !== 'play') return state;
  return <Glyph name="play" size={size} fill="currentColor" strokeWidth={1.5} />;
}
